module.exports = __webpack_public_path__ + "static/media/logout.2c72e490.svg";